import React__default from 'react';
import Divider from '../../../../Atoms/Divider.js';
import Colors from '../../../../Themes/Colors/colors.js';
import ItemSummaryCard from '../../../../Molecules/ItemSummaryCard.js';

function QsrBillBreakupShimmer() {
    return (React__default.createElement("div", { className: "qsr-bill_breakup--shimmer" },
        React__default.createElement("div", { className: "bill_breakup__header--shimmer" },
            React__default.createElement("div", { className: "token-number-label--shimmer" }),
            React__default.createElement("div", { className: "token-number--shimmer" })),
        React__default.createElement("div", { className: "bill_breakup__divider--shimmer" },
            React__default.createElement("div", { className: "semi_cirle_right--shimmer" }),
            React__default.createElement(Divider, { variant: "horizontal", classes: "divider__line--shimmer", color: Colors.GREY_THREE, dividerStyle: "dashed" }),
            React__default.createElement("div", { className: "semi_circle_left--shimmer" })),
        React__default.createElement("div", { className: "bill_breakup__body--shimmer" }, [1, 2, 3].map(function (_, index) { return (React__default.createElement(React__default.Fragment, { key: index },
            index !== 0 && (React__default.createElement(Divider, { variant: "horizontal", classes: "body__divider--shimmer", color: Colors.GREY_FIVE, dividerStyle: "solid" })),
            React__default.createElement(ItemSummaryCard, { loading: true }))); }))));
}

export { QsrBillBreakupShimmer as default };
//# sourceMappingURL=index.shimmer.js.map
